import "./App.css";
import { Route, Routes } from "react-router-dom";
import MainLayout from "./components/layout";
import Home from "./features/Home";

function App() {
  return (
    <Routes>
      <Route
        path="/"
        element={
          <MainLayout className="min-h-screen bg-[#1F1F1F] overflow-hidden">
            <Home />
          </MainLayout>
        }
      />
      <Route
        path="/chat"
        element={
          <MainLayout>
            <></>
          </MainLayout>
        }
      />
    </Routes>
  );
}

export default App;
